import { kebabCase } from 'lodash'

export function slugTranslationKey(input?: string | null): string {
  if (!input) {
    return ''
  }

  return kebabCase(input).replace(/([^a-zA-Z0-9._-]*)/gi, '')
}
